import { render, staticRenderFns } from "./page0.vue?vue&type=template&id=7c729bf2"
import script from "./page0.vue?vue&type=script&lang=js"
export * from "./page0.vue?vue&type=script&lang=js"
import style0 from "./page0.vue?vue&type=style&index=0&id=7c729bf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports